var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", md: "6" } },
            [
              _c(
                "div",
                {
                  staticClass: "text-h6 my-4 font-weight-black text-uppercase",
                },
                [
                  _vm._v(" Lists "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        icon: "",
                        "x-small": "",
                        color: "primary",
                        outlined: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showNewListDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v(" mdi-plus ")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lists.lists,
                  "items-per-page": 10,
                  loading: _vm.lists.loading,
                  "loading-text": "Loading...",
                  "single-select": false,
                  "item-key": "ID",
                  "hide-default-footer": _vm.lists.lists.length <= 10,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.post_title",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.goToList(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.post_title))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.post_date",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.goToList(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.app.formatDateUTC(item.post_date))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.goToList(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-eye")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          { attrs: { icon: "" } },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmDelete(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("v-col"),
        ],
        1
      ),
      _vm.lists.show_delete_dialog ? _c("dialog-delete-list") : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { width: "60%", "max-width": "500", persistent: "" },
          model: {
            value: _vm.show_new_list_dialog,
            callback: function ($$v) {
              _vm.show_new_list_dialog = $$v
            },
            expression: "show_new_list_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5 primary" }, [
                _vm._v(" New List "),
              ]),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4" },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "List name",
                      error: _vm.new_list_name_error,
                    },
                    model: {
                      value: _vm.new_list_name,
                      callback: function ($$v) {
                        _vm.new_list_name = $$v
                      },
                      expression: "new_list_name",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.show_new_list_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.saving_list,
                        disabled: _vm.saving_list,
                      },
                      on: { click: _vm.createList },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }